module.exports = __webpack_public_path__ + "static/media/gameplay_bg_02.5df48b20.jpg";